module.exports = __webpack_public_path__ + "static/media/close2.80dd2590.svg";